export enum topRecruiterTypes {
  FETCH_TOP_RECRUITER_REQUEST = "FETCH_TOP_RECRUITER_REQUEST",
  FETCH_TOP_RECRUITER_SUCCESS = "FETCH_TOP_RECRUITER_SUCCESS",
  FETCH_TOP_RECRUITER_FAILURE = "FETCH_TOP_RECRUITER_FAILURE",
}